import React, { useEffect, useState } from 'react';
import ConversationService from '../../../../../service';
import { validationFiles } from './assets/validationFiles';
import { generatePreview } from './assets/generatePreview';
import { addMessageConversationInAttendance } from '../../../../../../../store/action/conversation-in-attendance-action';
import { useSelector, useDispatch } from 'react-redux';
import { PreviewImage } from './components/PreviewImage';
import { PreviewPdf } from './components/PreviewPdf';
import { PreviewFile } from './components/PreviewFile';
import { imageExtensions, videoExtensions } from './components/assets';
import { Preview } from './components/styled';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { Input, Button, Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import DefaultModal from 'components/Modal/DefaultModal';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';
import Loader from 'react-loader-spinner';

const allowedExtensionsToSendCaption = ['telegram', 'whatsapp', 'chat'];

const UploadFile = ({
  id,
  defaultFiles = [],
  isModalOpen,
  onModalToggle,
  disabledSubmit = false,
  conversation,
  inReplyToMessageId,
  setInReplyToMessageId,
  ...props
}) => {
  const [files, setFiles] = useState([]);
  const [pdfPreview, setPdfPreview] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [
    fileExtensionsWithPreviewAlreadyGenerated,
    setFileExtensionsWithPreviewAlreadyGenerated
  ] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [messageText, setMessageText] = useState('');
  const {
    CheckedRefusedExtensionsFiles,
    isAllFilesWithApprovedExtension,
    isFilesWithApprovedExtension,
    isImagesWithApprovedExtension,
    sizeInvalidFileValidation
  } = validationFiles();
  const { getImagePreview, getPDFPreview } = generatePreview();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const dispatch = useDispatch();

  useEffect(() => {
    setConversationId(id);
  }, [id]);

  useEffect(() => {
    if (defaultFiles && defaultFiles.length) {
      onModalToggle(true);
      handleSelectFile(defaultFiles);
    }
  }, [defaultFiles]);

  useEffect(() => {
    if (!isModalOpen) {
      reset();
    }
  }, [isModalOpen]);

  const handleOnChangeFile = (event) => {
    const files = event.target.files;
    handleSelectFile(files);
  };

  const handleSelectFile = (files) => {
    reset();

    if (!files) return;

    const filesToBeSent = Array.from(files);

    const isCheckedRefusedExtensionsFiles =
      CheckedRefusedExtensionsFiles(filesToBeSent);

    if (isCheckedRefusedExtensionsFiles) {
      toast.error('Erro ao enviar arquivo(s). Formato não permitido');
      return;
    }

    const channelType = conversation.canal;
    const isInvalidTypeFile = isAllFilesWithApprovedExtension(
      filesToBeSent,
      channelType
    );

    if (Object.keys(isInvalidTypeFile).length !== 0) {
      toast.error(
        `${isInvalidTypeFile.message}: ${isInvalidTypeFile.extension}`
      );
      return;
    }

    const sizeValidationType =
      channelType === 'whatsapp'
        ? 'WHATSAPP'
        : channelType === 'instagram'
        ? 'INSTAGRAM'
        : 'CHAT';

    const isSizeFileValidation = sizeInvalidFileValidation(
      filesToBeSent,
      sizeValidationType
    );

    if (Object.keys(isSizeFileValidation).length !== 0) {
      toast.error(
        `${isSizeFileValidation.message} ${isSizeFileValidation.extension}`
      );
      return;
    }

    const imagesWithApprovedExtension =
      isImagesWithApprovedExtension(filesToBeSent);

    const selectedImagePreview = getImagePreview(imagesWithApprovedExtension);

    const filesWithApprovedExtension =
      isFilesWithApprovedExtension(filesToBeSent);

    const selectedPdfPreview = getPDFPreview(filesWithApprovedExtension);

    const getFileExtensionsWithPreviewAlreadyGenerated = [
      ...selectedImagePreview,
      ...selectedPdfPreview
    ].map((file) => {
      return file?.nameFile.split('.').pop();
    });

    setFileExtensionsWithPreviewAlreadyGenerated(
      getFileExtensionsWithPreviewAlreadyGenerated
    );
    setPreviewImages(selectedImagePreview);
    setPdfPreview(selectedPdfPreview);
    console.log(filesToBeSent);
    setFiles(filesToBeSent);
  };

  const onSubmit = async (sendFile) => {
    if (!sendFile) {
      return;
    }
    try {
      if (
        conversation.canal === 'whatsapp' ||
        conversation.canal === 'chat' ||
        conversation.canal === 'flex4u' ||
        conversation.canal === 'facebook' ||
        conversation.canal === 'telegram' ||
        conversation.canal === 'instagram'
      ) {
        const fileExtension = sendFile.name.split('.').pop();
        const dateNow = new Date();
        const formatedData = new FormData();

        formatedData.append('file', sendFile);
        formatedData.append('idDaConversa', conversationId); //body
        formatedData.append('cliente_ou_atendente', 'atendente'); //
        formatedData.append('escrita_por', localStorage.getItem('name'));
        formatedData.append(
          'legenda',
          `${sendFile.name}_upload_atendente_${dateNow.toLocaleDateString(
            'pt-br'
          )}-${dateNow.toLocaleTimeString('pt-br')}`
        );

        if (imageExtensions.includes(fileExtension)) {
          formatedData.append('response_type', 'image');
          formatedData.append('type', 'image');
        } else if (videoExtensions.includes(fileExtension)) {
          formatedData.append('response_type', 'video');
          formatedData.append('type', 'video');
        } else {
          formatedData.append('response_type', 'file');
          formatedData.append('type', 'file');
        }

        if (messageText.length > 0) {
          formatedData.append('caption', messageText);
        }

        if (conversation.canal === 'whatsapp') {
          if (inReplyToMessageId) {
            formatedData.append('inReplyTo', inReplyToMessageId);
          }
          FlexChatIntegration.uploadFile(conversationId, formatedData)
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data },
                  conversationId
                )
              );
              setInReplyToMessageId(null);
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (conversation.canal === 'flex4u') {
          await FlexChatIntegration.uploadFileFlex4U(formatedData)
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (conversation.canal === 'facebook') {
          await FlexChatIntegration.uploadFileFacebook(
            formatedData,
            conversationId
          )
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (conversation.canal === 'instagram') {
          await FlexChatIntegration.uploadFileInstagram(
            formatedData,
            conversationId
          )
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (conversation.canal === 'telegram') {
          await FlexChatIntegration.uploadFileTelegram(
            formatedData,
            conversationId
          )
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          await FlexChatIntegration.uploadFileWebchat(formatedData)
            .then((res) => {
              dispatch(
                addMessageConversationInAttendance(
                  { ...res.data.data },
                  conversationId
                )
              );
            })
            .catch((err) => {
              console.log(err);
            });
        }

        reset();
        toggleModal();

        return;
      }

      const fileExtension = sendFile.name.split('.').pop();
      const dateNow = new Date();
      const formatedData = new FormData();

      formatedData.append('files', sendFile);
      formatedData.append('idDaConversa', conversationId); //body
      formatedData.append('cliente_ou_atendente', 'atendente'); //
      formatedData.append('escrita_por', localStorage.getItem('name'));
      formatedData.append(
        'legenda',
        `${sendFile.name}_upload_atendente_${dateNow.toLocaleDateString(
          'pt-br'
        )}-${dateNow.toLocaleTimeString('pt-br')}`
      );

      if (imageExtensions.includes(fileExtension)) {
        formatedData.append('response_type', 'image');
        formatedData.append('type', 'image');
      } else if (videoExtensions.includes(fileExtension)) {
        formatedData.append('response_type', 'video');
        formatedData.append('type', 'video');
      } else {
        formatedData.append('response_type', 'file');
        formatedData.append('type', 'file');
      }
      await ConversationService.uploadFile(formatedData)
        .then((res) => {
          dispatch(
            addMessageConversationInAttendance({ ...res.data }, conversationId)
          );
        })
        .catch((err) => {
          console.log(err);
        });

      reset();
      toggleModal();
    } catch (err) {
      toast.error(err || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setMessageText('');
    }
  };

  const reset = () => {
    setFileExtensionsWithPreviewAlreadyGenerated([]);
    setPreviewImages([]);
    setPdfPreview([]);
    setFiles([]);
  };

  const toggleModal = () => {
    onModalToggle(false);
    reset();
  };

  const processSubmit = async () => {
    setIsSubmitting(true);
    try {
      for (const file of files) {
        await onSubmit(file);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title="Enviar Arquivo"
        showCloseButton={false}
        modalContainerClasses="modal-sm"
        {...props}
      >
        <hr style={{ marginTop: '-30px' }} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <label
            htmlFor="uploadFile"
            className="btn btn-primary btn-sm"
            style={buttonStyle(systemConfiguration.confirmation_button_color)}
          >
            {Object.keys(files).length
              ? 'Escolher outro(s)'
              : 'Selecionar arquivo(s)'}
          </label>
          <Input
            style={{ display: 'none' }}
            type="file"
            id="uploadFile"
            multiple
            name="uploadFile"
            onChange={handleOnChangeFile}
          />
        </div>

        <Row className="mt-2 mb-2">
          <Col className="d-flex justify-content-center">
            <Preview>
              {!!Object.keys(previewImages).length &&
                previewImages.map((previewImage, index) => {
                  return (
                    <PreviewImage key={index} previewImage={previewImage} />
                  );
                })}

              {!!Object.keys(pdfPreview).length &&
                pdfPreview.map((filePreview, index) => {
                  return <PreviewPdf key={index} filePreview={filePreview} />;
                })}

              {!!Object.keys(files).length &&
                files.map(
                  (file, index) =>
                    fileExtensionsWithPreviewAlreadyGenerated.includes(
                      file.name.split('.').pop()
                    ) === false && <PreviewFile key={index} file={file} />
                )}
            </Preview>
          </Col>
        </Row>

        {files.length > 0 &&
          allowedExtensionsToSendCaption.includes(conversation.canal) && (
            <Row className="mt-2 mb-2">
              <Col className="d-flex justify-content-center">
                <Input
                  value={messageText}
                  onChange={(event) => {
                    const message = event.target.value;
                    setMessageText(message);
                  }}
                  type="text"
                  placeholder="Adicione uma legenda..."
                />
              </Col>
            </Row>
          )}

        <Row className="mt-5">
          <Col>
            <Button
              disabled={disabledSubmit || isSubmitting}
              style={buttonStyle(systemConfiguration.confirmation_button_color)}
              onClick={processSubmit}
            >
              {isSubmitting ? (
                <Loader
                  type="ThreeDots"
                  visible={true}
                  height="10"
                  width="40"
                />
              ) : (
                'Enviar'
              )}
            </Button>
            <Button
              style={buttonStyle(systemConfiguration.cancelation_button_color)}
              onClick={toggleModal}
            >
              Cancelar
            </Button>
          </Col>
        </Row>
      </DefaultModal>
    </>
  );
};

export default UploadFile;
